import * as StoreAPI from "src/core/api/shops";

export async function getStoreSocials(axiosInstance) {
  const response = await StoreAPI.socials(axiosInstance);
  return response.data;
}
